import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

import workflowImg from "../assets/projects/wolf.jpeg";
import eventImg from "../assets/projects/event.jpeg";
import portfolioImg from "../assets/projects/portfolio.png";

export default function Work() {
    const [selectedProject, setSelectedProject] = useState(null);

    const projects = [
        {
            title: "Ecommerce Integration with CMS",
            category: "Full Stack Development",
            description:
                "Building a headless CMS integration with NextJS for an e-commerce platform.",
            tech: ["Next.js", "Framer Motion", "API"],
            image: workflowImg,
            live: "#",
            github: "#",
        },

        {
            title: "Creative Portfolio Platform",
            category: "Frontend Engineering",
            description:
                "Out of the box portfolio template built with ReactJS and TailwindCSS for smooth interactions.",
            tech: ["React", "UI/UX", "Tailwind"],
            image: portfolioImg,
            live: "#",
            github: "#",
        },

        {
            title: "Event Management System",
            category: "UI / UX + Data",
            description:
                "Responsive front end event planning platform with interactive calendar and data visualization features.",
            tech: ["ReactJS", "TailwindCSS", "UI/UX"],
            image: eventImg,
            live: "#",
            github: "#",
        },
    ];

    return (
        <section
            id="work"
            className="
        relative py-32
        bg-[#0b0b0f]
        text-white overflow-hidden
      "
        >

            {/* BACKGROUND GLOWS */}
            <div className="absolute inset-0 pointer-events-none">

                <div className="
                    absolute top-0 left-1/4
                    w-[500px] h-[500px]
                    bg-cyan-500/10
                    blur-[160px]
                    rounded-full"
                />

                <div className="
                    absolute bottom-0 right-1/4
                    w-[450px] h-[450px]
                    bg-purple-500/10
                    blur-[160px]
                    rounded-full"
                />
            </div>

            <div className="max-w-7xl mx-auto px-6 relative z-10">

                {/* HEADER */}
                <div className="mb-16">

                    <p className="
                    uppercase tracking-[0.3em]
                    text-cyan-400 text-xs">
                        Featured Work
                    </p>

                    <h2 className="
            text-4xl md:text-5xl
            font-bold mt-4
          ">
                        Selected Projects
                    </h2>

                    <p className="
            text-zinc-400 mt-6
            max-w-2xl leading-relaxed
          ">
                        A collection of modern interfaces, systems,
                        and frontend experiences I’ve designed and built.
                    </p>
                </div>

                {/* PROJECT GRID */}
                <div className="grid lg:grid-cols-3 gap-8">

                    {projects.map((project, index) => (

                        <motion.div
                            onClick={() => setSelectedProject(project)}
                            cursor-pointer
                            key={project.title}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{
                                duration: 0.6,
                                delay: index * 0.15,
                            }}
                            viewport={{ once: true }}
                            whileHover={{
                                y: -10,
                            }}
                            className="
                group relative overflow-hidden
                rounded-[2rem]

                border border-white/10
                bg-white/5
                backdrop-blur-xl

                hover:border-cyan-500/30
                hover:shadow-[0_0_40px_rgba(34,211,238,0.08)]

                transition-all duration-500
              "
                        >

                            {/* IMAGE */}
                            <div className="
                relative overflow-hidden
                border-b border-white/10
              ">

                                {/* fake browser bar */}
                                {/* <div className="
                  flex items-center gap-2
                  px-4 py-3 bg-black/40
                  border-b border-white/5
                ">

                                    <div className="w-3 h-3 rounded-full bg-red-400" />
                                    <div className="w-3 h-3 rounded-full bg-yellow-400" />
                                    <div className="w-3 h-3 rounded-full bg-green-400" />

                                </div> */}

                                <img
                                    src={project.image}
                                    alt={project.title}
                                    className="
                    w-full h-[240px]
                    object-cover

                    group-hover:scale-105

                    transition-transform duration-700
                  "
                                />

                                {/* image glow overlay */}
                                <div className="
                  absolute inset-0
                  bg-gradient-to-t
                  from-black/50
                  via-transparent
                  to-transparent
                " />
                            </div>

                            {/* CONTENT */}
                            <div className="p-8">

                                <p className="
                  text-xs uppercase tracking-[0.2em]
                  text-zinc-500 mb-4
                ">
                                    {project.category}
                                </p>

                                <h3 className="
                  text-2xl font-bold mb-4
                ">
                                    {project.title}
                                </h3>

                                <p className="
                  text-zinc-400
                  leading-relaxed mb-6
                ">
                                    {project.description}
                                </p>

                                {/* TECH STACK */}
                                <div className="
                  flex flex-wrap gap-2 mb-8
                ">

                                    {project.tech.map((tech) => (
                                        <span
                                            key={tech}
                                            className="
                        px-3 py-1 rounded-full
                        text-sm

                        bg-black/30
                        border border-white/10
                        text-zinc-300

                        group-hover:border-cyan-500/20
                        transition
                      "
                                        >
                                            {tech}
                                        </span>
                                    ))}

                                </div>

                                {/* BUTTONS */}
                                <div className="flex gap-4">

                                    <a
                                        href={project.live}
                                        className="
                      px-5 py-3 rounded-xl

                      bg-cyan-500/15
                      border border-cyan-500/30
                      text-cyan-300

                      hover:bg-cyan-500/25
                      hover:shadow-[0_0_30px_rgba(34,211,238,0.15)]

                      transition-all duration-300
                    "
                                    >
                                        Live Demo
                                    </a>

                                    <a
                                        href={project.github}
                                        className="
                      px-5 py-3 rounded-xl

                      border border-white/10
                      text-white

                      hover:border-cyan-500/30
                      hover:text-cyan-300

                      transition-all duration-300
                    "
                                    >
                                        GitHub
                                    </a>

                                </div>
                            </div>

                            {/* HOVER GLOW */}
                            <div className="
                absolute inset-0
                opacity-0 group-hover:opacity-100
                transition-opacity duration-500
                pointer-events-none

                bg-gradient-to-br
                from-cyan-500/5
                via-transparent
                to-purple-500/5
              " />
                        </motion.div>
                    ))}
                </div>
            </div>
            <AnimatePresence>

                {selectedProject && (

                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}

                        className="
        fixed inset-0 z-[100]
        bg-black/80 backdrop-blur-xl

        flex items-center justify-center
        p-6
      "
                    >

                        {/* CLOSE BACKDROP */}
                        <div
                            className="absolute inset-0"
                            onClick={() => setSelectedProject(null)}
                        />

                        {/* MODAL */}
                        <motion.div
                            initial={{
                                opacity: 0,
                                scale: 0.92,
                                y: 40,
                            }}

                            animate={{
                                opacity: 1,
                                scale: 1,
                                y: 0,
                            }}

                            exit={{
                                opacity: 0,
                                scale: 0.95,
                                y: 20,
                            }}

                            transition={{
                                duration: 0.35,
                            }}

                            className="
          relative z-10

          w-full max-w-5xl
          max-h-[90vh]
          overflow-y-auto

          rounded-[2rem]

          border border-white/10
          bg-[#0f0f14]
          shadow-[0_0_80px_rgba(34,211,238,0.08)]

          overflow-hidden
        "
                        >

                            {/* IMAGE */}
                            <div className="relative">

                                {/* fake browser bar */}
                                <div className="
            flex items-center gap-2
            px-5 py-4
            bg-black/40
            border-b border-white/5
          ">

                                    <div className="w-3 h-3 rounded-full bg-red-400" />
                                    <div className="w-3 h-3 rounded-full bg-yellow-400" />
                                    <div className="w-3 h-3 rounded-full bg-green-400" />

                                </div>

                                <img
                                    src={selectedProject.image}
                                    alt={selectedProject.title}
                                    className="
              w-full h-[420px]
              object-cover
            "
                                />

                                {/* IMAGE OVERLAY */}
                                <div className="
            absolute inset-0
            bg-gradient-to-t
            from-[#0f0f14]
            via-transparent
            to-transparent
          " />
                            </div>

                            {/* CONTENT */}
                            <div className="p-10">

                                {/* CATEGORY */}
                                <p className="
            uppercase tracking-[0.25em]
            text-cyan-400 text-xs mb-5
          ">
                                    {selectedProject.category}
                                </p>

                                {/* TITLE */}
                                <h2 className="
            text-4xl md:text-5xl
            font-bold leading-tight
          ">
                                    {selectedProject.title}
                                </h2>

                                {/* DESCRIPTION */}
                                <p className="
            mt-8 text-zinc-400
            leading-relaxed text-lg
            max-w-3xl
          ">
                                    {selectedProject.description}
                                </p>

                                {/* FEATURES */}
                                <div className="mt-10">

                                    <h3 className="
              text-xl font-semibold mb-5
            ">
                                        Key Features
                                    </h3>

                                    <div className="
              grid md:grid-cols-2 gap-4
            ">

                                        {[
                                            "Responsive modern interface",
                                            "Smooth frontend animations",
                                            "Reusable component architecture",
                                            "Performance-focused structure",
                                        ].map((feature) => (

                                            <div
                                                key={feature}
                                                className="
                    p-4 rounded-2xl

                    bg-white/5
                    border border-white/10

                    text-zinc-300
                  "
                                            >
                                                {feature}
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* TECH STACK */}
                                <div className="mt-10">

                                    <h3 className="
              text-xl font-semibold mb-5
            ">
                                        Tech Stack
                                    </h3>

                                    <div className="flex flex-wrap gap-3">

                                        {selectedProject.tech.map((tech) => (

                                            <span
                                                key={tech}
                                                className="
                    px-4 py-2 rounded-full

                    bg-cyan-500/10
                    border border-cyan-500/20

                    text-cyan-300
                  "
                                            >
                                                {tech}
                                            </span>
                                        ))}

                                    </div>
                                </div>

                                {/* BUTTONS */}
                                <div className="
                                mt-12 flex flex-wrap gap-4
                                ">

                                    <a
                                        href={selectedProject.live}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="
                                        px-6 py-4 rounded-2xl

                                        bg-cyan-500/15
                                        border border-cyan-500/30

                                        text-cyan-300

                                        hover:bg-cyan-500/25
                                        hover:shadow-[0_0_40px_rgba(34,211,238,0.18)]

                                        transition-all duration-300
                                        "
                                    >
                                        View Live Project
                                    </a>

                                    <a
                                        href={selectedProject.github}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="
                                        px-6 py-4 rounded-2xl

                                        border border-white/10
                                        text-white

                                        hover:border-cyan-500/30
                                        hover:text-cyan-300

                                        transition-all duration-300
                                    "
                                    >
                                        View GitHub
                                    </a>

                                </div>

                                {/* CLOSE BUTTON */}
                                <button
                                    onClick={() => setSelectedProject(null)}
                                    className="
              absolute top-5 right-5

              w-12 h-12 rounded-full

              bg-white/5
              border border-white/10

              text-white text-xl

              hover:border-cyan-500/30
              hover:text-cyan-300

              transition-all duration-300
            "
                                >
                                    ✕
                                </button>

                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
}